"use client"

import NextLink from "app/projects/[projectId]/routing/_components/NextLink"
import useIsSandbox from "components/sandbox/useIsSandbox"
import { Button } from "src/orca/components/Button/Button"
import Icon from "src/orca/components/Icon/Icon"
import { Typography } from "src/orca/components/Typography/typography"

const SandboxBanner = () => {
  const isSandbox = useIsSandbox()

  if (!isSandbox) {
    return null
  }

  // if sandbox banner height is modified, we need to update PageLoading.tsx as well
  return (
    <div className="flex justify-center items-center gap-tokens-space-12 h-tokens-height-40 bg-tokens-surface-toast-warning-sandbox">
      <Icon name="Sandbox" />
      <Typography variant="ui14" weight="regular">
        You are in Sandbox mode. No real changes on the production will be processed.
      </Typography>
      <NextLink href="https://docs.processout.com/docs/testing-in-the-sandbox" target="_blank">
        <Button size={32} variant="ghost" rightIcon={<Icon name="ArrowLineUpRight" />}>
          Learn more
        </Button>
      </NextLink>
    </div>
  )
}

export default SandboxBanner
